import img1 from '/static/img/productImg/chuanxiFive/img1.jpg'
import img2 from '../../static/img/productImg/chuanxiSix/img1.jpg'
import img3 from '../../static/img/productImg/chuanxiSeven/img1.jpg'
import img4 from '../../static/img/productImg/chengduThree/img1.jpg'
import img5 from '../../static/img/productImg/chengduFive/img1.jpg'
import img6 from '../../static/img/productImg/guangzhouFiveB/img1.jpg'
import specialOffersImg1 from '../../static/img/productImg/SpecialOffers/img1.jpg'
import specialOffersImg2 from '../../static/img/productImg/SpecialOffers/img2.jpg'
import specialOffersImg3 from '../../static/img/productImg/SpecialOffers/img3.jpg'
import location from '../../static/img/home/location.png'
import location1 from '../../static/img/home/location1.png'
import explorePopularImg1 from '../../static/img/productImg/explorePopular/ganzi/img1.jpg'
import explorePopularImg2 from '../../static/img/productImg/explorePopular/ganzi/img2.jpg'
import explorePopularImg3 from '../../static/img/productImg/explorePopular/ganzi/img3.jpg'
import explorePopularImg4 from '../../static/img/productImg/explorePopular/ganzi/img4.jpg'
import explorePopularImg5 from '../../static/img/productImg/explorePopular/chengdu/img1.jpg'
import explorePopularImg6 from '../../static/img/productImg/explorePopular/chengdu/img2.jpg'
import explorePopularImg7 from '../../static/img/productImg/explorePopular/chengdu/img3.jpg'
import explorePopularImg8 from '../../static/img/productImg/explorePopular/chengdu/img4.jpg'
import explorePopularImg9 from '../../static/img/productImg/explorePopular/chongqing/img1.jpg'
import explorePopularImg10 from '../../static/img/productImg/explorePopular/chongqing/img2.jpg'
import explorePopularImg11 from '../../static/img/productImg/explorePopular/chongqing/img3.jpg'
import explorePopularImg12 from '../../static/img/productImg/explorePopular/chongqing/img4.jpg'
import explorePopularImg13 from '../../static/img/productImg/explorePopular/guangzhou/img1.jpg'
import explorePopularImg14 from '../../static/img/productImg/explorePopular/guangzhou/img2.jpg'
import explorePopularImg15 from '../../static/img/productImg/explorePopular/guangzhou/img3.jpg'
import explorePopularImg16 from '../../static/img/productImg/explorePopular/guangzhou/img4.jpg'
import userImg1 from '../../static/img/home/Image-Placeholder.png'
import userImg2 from '../../static/img/home/Image-Placeholder1.png'
import userImg3 from '../../static/img/home/Image-Placeholder2.png'
import userImg4 from '../../static/img/home/Image-Placeholder3.png'
import userImg5 from '../../static/img/home/Image-Placeholder4.png'
const productsList = [
    {
      id:1,
      lable:'Most popular',
      // price:"Save $300",
      price:'',
      desc:"Five days tour: Mt. Xuedo + Gediram + Ghenye + Xinduqiao",
      // time:"7 nights, Departure on 2021, June 23",
      time:'',
      img:img1,
      // discount:'RM580',
      // noPrice:"RM980",
      discount:'-',
      noPrice:"-",
    },
    {
      id:2,
      lable:'Most popular',
      // price:"Save $300",
      price:'',
      desc:"Value six-day tour: Mt. Xueduo+Xinduqiao+Ge'nie+Murshi Park+Siguniang Mountain",
      // time:"7 nights, Departure on 2021, June 23",
      time:'',
      img:img2,
      // discount:'RM580',
      // noPrice:"RM980",
      discount:'-',
      noPrice:"-",
    },
    {
      id:3,
      lable:'Most popular',
      // price:"Save $300",
      price:'',
      desc:"Western Sichuan 7 Days: Mt. Xueduo+Gediram+Ge'nie+Daocheng Yading",
      // time:"7 nights, Departure on 2021, June 23",
      // discount:'RM580',
      // noPrice:"RM980",
      time:'',
      img:img3,
      discount:'-',
      noPrice:"-",
    },
    {
      id:4,
      lable:'Most popular',
      // price:"Save $300",
      price:'',
      desc:"3 Days in Chengdu: Panda Bus, Three Kingdoms Tour",
      // time:"7 nights, Departure on 2021, June 23",
      // discount:'RM580',
      // noPrice:"RM980",
      time:'',
      img:img4,
      discount:'-',
      noPrice:"-",
    },
    {
      id:5,
      lable:'Most popular',
      // price:"Save $300",
      price:'',
      desc:"5 Days Citywalk, Panda base, ancient streets and museums",
      // time:"7 nights, Departure on 2021, June 23",
      // discount:'RM580',
      // noPrice:"RM980",
      time:'',
      img:img5,
      discount:'-',
      noPrice:"-",
    },
    {
      id:7,
      lable:'Most popular',
      // price:"Save $300",
      price:'',
      desc:"5 Days in Lingnan: Taste of Canton + Shunde Cuisine + Foshan Martial Arts + Spa Healing",
      // time:"7 nights, Departure on 2021, June 23",
      // discount:'RM580',
      // noPrice:"RM980",
      time:'',
      img:img6,
      discount:'-',
      noPrice:"-",
    },
  ]

  const specialOffersList =[
    {
      id:1,
      img:specialOffersImg1,
      name:"Siguniang Mountain",
      position:"sichuan",
      positionImg:location1,
    },
    {
      id:2,
      img:specialOffersImg2,
      name:"Daocheng Yading",
      position:"sichuan",
      positionImg:location,
      desc:'In 1928, American explorer Joseph Rock came here and introduced the pristine ecological beauty of In daocheng Yading to the world, and since then it has been hailed as “the last Shangri-La” and “the last piece of pure land on the blue planet.”',
      btn1:"Book Now",
      btn2:"Learn More",
    },
    {
      id:3,
      img:specialOffersImg3,
      name:"Murshi Park",
      position:"sichuan",
      positionImg:location1,
    }
  ]
  const navList = [
    { name:'All', id: 1 },
    { name:'Ganzi', id: 2 },
    { name: 'Chengdu', id: 3 },
    { name: 'Chongqing', id: 4 },
    { name:'Guangzhou', id: 5 },
  ]
  const explorePopularList = [
    {
      img:explorePopularImg1,
      name:"Daocheng Yading",
      position:"Ganzi",
      positionImg:"",
      id:1,
    },
    {
      img:explorePopularImg2,
      name:"Gediram",
      position:"Ganzi",
      positionImg:"",
      id:2,
    },
    {
      img:explorePopularImg3,
      name:"Siguniang Mountain",
      position:"Ganzi",
      positionImg:"",
      id:3,
    },
     {
      img:explorePopularImg4,
      name:"ink stone park",
      position:"Ganzi",
      positionImg:"",
      id:4,
    },
    {
      img:explorePopularImg5,
      name:"Dujiangyan",
      position:"chengdu",
      positionImg:"",
      id:5,
    },
    {
      img:explorePopularImg6,
      name:"Dongjiao Memory",
      position:"Chengdu",
      positionImg:"",
      id:6,
    },
    {
      img:explorePopularImg7,
      name:"Kuanzhai Alleys",
      position:"Chengdu",
      positionImg:"",
      id:7,
    },
    {
      img:explorePopularImg8,
      name:"Giant Panda Breeding Base",
      position:"Chengdu",
      positionImg:"",
      id:8,
    },
    {
      img:explorePopularImg9,
      name:"Hongyadong",
      position:"Chongqing",
      positionImg:"",
      id:9,
    },
    {
      img:explorePopularImg10,
      name:"Nanshan Yikeshu Viewpoint",
      position:"Chongqing",
      positionImg:"",
      id:10,
    },
    {
      img:explorePopularImg11,
      name:"Wulong sinkhole",
      position:"Chongqing",
      positionImg:"",
      id:11,
    },
    {
      img:explorePopularImg12,
      name:"Fairy Mountain Grassland",
      position:"Chongqing",
      positionImg:"",
      id:12,
    },
    {
      img:explorePopularImg13,
      name:"Lingnan Impression Park",
      position:"Guangzhou",
      positionImg:"",
      id:13,
    },
    {
      img:explorePopularImg14,
      name:"Canton Tower",
      position:"Guangzhou",
      positionImg:"",
      id:14,
    },
    {
      img:explorePopularImg15,
      name:"Diamond Beach of Dong'ao Island",
      position:"Guangzhou",
      positionImg:"",
      id:15,
    },
    {
      img:explorePopularImg16,
      name:"Chimelong Safari Park",
      position:"Guangzhou",
      positionImg:"",
      id:16,
    }
  ]
  const userList = [
    {
      id:1,
      img:userImg1,
      name:"",
      adress:"",
    },
    {
      id:2,
      img:userImg2,
      name:"",
      adress:"",
    },
    {
      id:3,
      img:userImg3,
      name:"",
      adress:"",
    },
    {
      id:4,
      img:userImg4,
      name:"Sarah Johnson",
      adress:"Client from United States of America",
    },
    {
      id:5,
      img:userImg5,
      name:"",
      adress:"",
    },
  ]
  const CaseStudyInfo = {
    desc:"“From Smoky Chengdu to Snowy Paradise 318 is not only a highway, but also an expedition about freedom and faith - where every step is a landscape and every journey is a story. ”",
    desc1:'bbgmove Planner',
    desc2:'Recommended travel destinations',
    btn:'Case Study'
  }
  const startYourTravelInfo = {
    title:"Start Your Travel",
    desc:"Don't miss out on the adventure - consult our travel products today!",
    btn:"contract us"
  }
  export default{
    startYourTravelInfo,
    CaseStudyInfo,
    explorePopularList,
    productsList,
    navList,
    specialOffersList,
    userList
  }